export const PERIODS_FOR_STATS = [

  { id: 'today', name: 'сегодня' },
  { id: 'yesterday', name: 'вчера' },
  { id: 'week', name: 'неделя' },
  { id: 'month', name: 'месяц' },
  { id: 'year', name: 'год' },
  { id: 'period', name: 'период' },

];

export const CURRENT_OR_PAST = [

  { id: 'current', name: 'текущий' },
  { id: 'past', name: 'прошлый' },

];